import React from "react";
import { Zap, Infinity as InfinityIcon } from "lucide-react";
import { useCredits } from "@/context/CreditsContext";

export default function CreditPill() {
  const { credits, openTopUp } = useCredits();
  if (!credits) return null;

  if (credits.unlimited) {
    return (
      <span
        data-testid="credit-pill"
        title="Unlimited AI credits"
        className="inline-flex items-center gap-1 rounded-full border border-border bg-secondary/50 px-2.5 h-8 text-xs font-semibold text-muted-foreground"
      >
        <InfinityIcon className="w-3.5 h-3.5 text-primary" /> AI credits
      </span>
    );
  }

  const low = credits.total <= 4;
  return (
    <button
      type="button"
      onClick={openTopUp}
      data-testid="credit-pill"
      title="AI credits — click to top up"
      className={`inline-flex items-center gap-1 rounded-full border px-2.5 h-8 text-xs font-semibold transition-colors ${
        low
          ? "border-amber-500/50 bg-amber-500/10 text-amber-600 dark:text-amber-300 hover:bg-amber-500/20"
          : "border-border bg-secondary/50 text-foreground hover:bg-secondary"
      }`}
    >
      <Zap className="w-3.5 h-3.5 text-primary" />
      <span data-testid="credit-pill-count">{credits.total}</span>
      <span className="hidden sm:inline font-normal text-muted-foreground">credits</span>
    </button>
  );
}
